export class HrMasterDataRouterConstants {
    public static readonly MASTER_DATA_MAIN_ROUTE = '/humanresources/personnel/operation/personnel-creation/boxes';
    public static readonly PAYROLL_CARDS_BOX_ROUTE = 'payroll-cards';
    public static readonly WAGE_MANAGEMENT_CARDS_BOX_ROUTE = 'wage-management';
    public static readonly TIME_MANAGEMENT_CARDS_BOX_ROUTE = 'time-management';
    public static readonly SHOW_BACK_QUERY_PARAM = 'showBack';
    public static readonly CUSTOM_BACK_ROUTE_QUERY_PARAM = 'customBackRoute';
    public static readonly LABEL_ROUTE_QUERY_PARAM = 'label';

    private constructor() {}
}
